import _ = require("lodash")
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {UIApplicationBO} from "./UIApplicationBO";
import {
    WB_UIAppModuleRow,
} from "../PA.Core/PAdbSchemaRows";
import {CustomerBO} from "../PA.MD.BusinessObjects/CustomerBO";
import { ErrorMessage_restate, ExceptionMessage_restate } from "../PA.Core/Basic/MessageUtils";

export class UIApplicationBOValidation {

    static async RunValidations(aBO: UIApplicationBO): Promise<void> {

        try {
            //  Startup Validation looks old, search sessions appear now.
            //await UIApplicationBOValidation.ValidateStartupPolicy(aBO)

            await UIApplicationBOValidation.ValidateToolbarSelection(aBO)
        } catch (e) {
            ExceptionMessage_restate(aBO.ValidateMessageProvider, e)
        }

    }

    static async ValidateToolbarSelection(aBO: UIApplicationBO): Promise<void> {
        if(aBO.WB_UIApplication.cif.MODULE_BAR_POLICY != "ShowToolbar")
            return

        _.forEach(aBO.WB_UIApplication.WB_UIAppModuleRows, (aRow) => {
            if(!aRow.isActive)
                return

            switch(aRow.cif.PLACEMENT_POLICY){
                case "Toolbar":
                case "ToolbarFooter":
                    if(!aRow.cif.UI5_ICON.startsWith("sap-icon")){
                       ErrorMessage_restate(aBO.ValidateMessageProvider, true, `${aRow.cif.WB_UI_APPMODULE_ID}-icon`,
                           `App Module, ${aRow.cif.APPMODULE_NAME}, must use SAP icon when using Module Bar Policy = Toolbar`)
                    }
                    break;

                case "PaneContainer":
                case "Dashboard":
                case  "MainPane":
                case "None":
                    break;
                default:
                    ErrorMessage_restate(aBO.ValidateMessageProvider, true, `${aRow.cif.WB_UI_APPMODULE_ID}-placement`,
                        `App Module, ${aRow.cif.APPMODULE_NAME}, has unknown Placement Policy`)
                    break;
            }

        })
    }

    static async ValidateStartupPolicy(aBO: UIApplicationBO): Promise<void> {

        let countAutoStart = 0;

        _.forEach(aBO.WB_UIApplication.WB_UIAppModuleRows, (aRow: WB_UIAppModuleRow) => {
            if (!aRow.isActive)
                return

            if ((aRow.cif.STARTUP_POLICY === "AutoStart" || aRow.cif.STARTUP_POLICY === "AutoStartSearch"))
                countAutoStart += 1
        })

        ErrorMessage_restate(aBO.ValidateMessageProvider,
            (countAutoStart > 1),
            'startupPolicy',
            "Only 1 module may be specified as \"Auto Start\" or \"Auto Start Search\", please update module configuration before saving.")

    }

}